import React from 'react';
import { withRouter } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';
import './ProSettingsScreen.scss'

import { ADS_MAKER_TYPE } from '../../types/types'

import { Button } from 'reactstrap'
import { Fire, Popup, Tools, Stripe } from '../../services'

import { Headerbar, FormInput } from '../Reusable'
import { updateUser } from '../../actions/auth.action'

import FadeIn from 'react-fade-in';
import ProInfoForm from './ProInfoForm'

interface Props {

}
const ProSettingsScreen: React.FC<Props> = (props) => {

  const user = useSelector(state => state.authReducer.user)
  const fireUser = useSelector(state => state.authReducer.fireUser)
  const dispatch = useDispatch()

  const save = async (info: any) => {
    try {
      await dispatch(updateUser(info))
    } catch (err) {
      console.error(err)
    }
  }

  const deleteAccount = async () => {
    const confirm = window.confirm('Êtes-vous sûr de vouloir supprimer définitevement votre compte ?')
    if (!confirm)
      return

    try {
      await fireUser.delete()
    } catch (err) {

      switch (err.code) {
        case "auth/requires-recent-login":
          Popup.show({
            type: 'input',
            settings: {
              title: 'Vérifiez votre identité',
              confirmText: 'Valider',
              placeholder: 'Votre mot de passe',
              onConfirm: async (password: string) => {
                const email = fireUser.email
                try {
                  await Fire.reauthEmail(email, password)
                  await fireUser.delete()
                  Popup.hide()
                } catch (err) {
                  Popup.hide()
                  setTimeout(() => {

                    switch (err.code) {
                      case "auth/wrong-password":
                        Popup.show({
                          type: 'info',
                          settings: {
                            title: 'Erreur',
                            text: 'Le mot de passe entré est incorrect'
                          }
                        })
                        break;
                      
                      default:

                        Popup.show({
                          type: 'info',
                          settings: {
                            title: 'Erreur',
                            text: 'Une erreur est survenue, veuillez contacter Pop Out'
                          }
                        })
                        break;
                    }
                  }, 600)
                  
                }
              },

              onCancel: () => Popup.hide(),
            }
          })
          break;
        
        default:
          Popup.show({
            type: 'info',
            settings: {
              title: 'Erreur',
              text: 'Une erreur est survenue, veuillez contacter Pop Out'
            }
          })  
          break;
      }
    }
  }

  const resetPassword = () => {
    Popup.show({
      type: 'info',
      settings: {
        title: 'Réinitialisation de mot de passe',
        text: 'Êtes-vous sûr de vouloir réinitialiser votre mot de passe ? Un mail vous sera envoyé pour procéder à la modification.',
        confirmText: 'Continuer',
        onConfirm: async (password: string) => {
          Popup.hide()
          try {
            await Fire.auth().sendPasswordResetEmail(user.email)
            Popup.show({
              type: 'info',
              settings: {
                title: 'Mail envoyé',
                text: 'Votre mail de réinitialisation de mot de passe a été envoyé',
                confirmText: 'OK',
              }
            })  
          } catch (err) {
            Popup.show({
              type: 'info',
              settings: {
                title: 'Erreur',
                text: 'Une erreur est survenue, veuillez contacter Pop Out',
                confirmText: 'OK',
              }
            })  
          }
        }
      }
    })
  }

  const setupAccount = () => {
    Stripe.setupAccount(user.id)
  }

  const openLink = () => {
    window.location.href = user.stripe_link
  }

  return (
    <div className="wrapper">
      <Headerbar
        title={"Votre compte"}
        />

      <div className="content-wrapper">
        <div className="content">
          <div className="container-fluid settings">

            <FadeIn>

              { user.type !== ADS_MAKER_TYPE &&

                <div className="card">
                  <div className="card-header">
                    <div className="row spaced-row">
                      <h3 className="card-title">Configuration paiement</h3>
                      { user.stripe_verified ? (
                        <span className="text-success">Configuré <i style={{marginLeft: 10}} className="fa fa-check"></i></span>
                      ) : user.stripe_link ? (
                        <span className="text-warning">En configuration</span> 
                      ) : (
                        <span className="text-warning">Non configuré</span> 
                      )}
                    </div>
                  </div>

                  <div className="card-body">
                    <div>Vous devez configurer vos informations bancaires: <br />
                     - poour utiliser notre billeterie<br />
                     - pour recevoir vos virements automatiques<br /><br />
                     Statut: {user.stripe_verified ? 'Validé' : user.stripe_link ? 'En création' : 'Non configuré'}                   
                     </div>
                    { !user.stripe_verified &&
                      <Button
                        onClick={user.stripe_link ? openLink : setupAccount}
                        className="btn-info"
                        >
                          {user.stripe_link ? 'Terminer la configuration' : 'Configurer maintenant'}
                      </Button>
                    }
                  </div>
                </div>
              }

              <ProInfoForm
                title='Vos informations'
                pro={user}

                onSave={save}
                />

              <div className="col-centered">
                <div onClick={resetPassword} className="btn-link">Réinitialiser mon mot de passe</div>
                <div onClick={deleteAccount} className="btn-remove">Supprimer mon compte</div>
              </div>

            </FadeIn>

          </div>
        </div>
      </div>
    </div>
  );
}

export default ProSettingsScreen